import APIClient from './APIClient';

const {
  REACT_APP_ONBOARDING_API_HOST: ONBOARDING_API_HOST,
  REACT_APP_MINIMUM_LOAN_SIZE_ENDPOINT: LOAN_SIZE_ENDPOINT,
} = process.env;

export const urlFor = (eligibilityId, courseMinLoanSize) =>
  `${ONBOARDING_API_HOST}${LOAN_SIZE_ENDPOINT}`
    .replace('{eligibilityId}', eligibilityId)
    .replace('{courseMinLoanSize}', courseMinLoanSize);

export default class MinimumLoanSizeAPI {
  static queryMinimumLoanSizeFor = (eligibilityId, courseMinLoanSize, token) => {
    return APIClient.get(urlFor(eligibilityId, courseMinLoanSize), token).then(
      response => response.data,
    );
  };
}
